export enum ReportNameEnum {
  gm = "gm",
  po = "po",
  bpm = "bpm",
  aed = "thermometer",
}
